import React, { useMemo } from 'react'
import { Box, Chip, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { AppBulkEditAction, AppDialogCancel, AppModal } from "@components"
import { dsColorNew } from "@palette"
import { originalUserData, showSaveConfirm, userPayload } from "Pages/Admin/Users/@signals"
import useCreateUsersModal from "Pages/Admin/Users/@hooks/useCreateModal"
import { computeDiff } from "Pages/Admin/Users/@utils/diff"

export default function ConfirmSaveModal() {
	const { onSubmitModal, isEditLoading } = useCreateUsersModal()

	const changes = useMemo(
		() => computeDiff(originalUserData.value, userPayload.value),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[showSaveConfirm.value]
	)

	if (!showSaveConfirm.value) return null

	return <AppModal
		hideActions
		icon="floppy-disk"
		title="Confirm changes"
		subtitle={changes.length ? `${changes.length} change${changes.length === 1 ? '' : 's'} to save` : 'Nothing changed'}
		containerProps={{ maxWidth: 'sm' }}
		isOpen={showSaveConfirm.value}
		controller={() => { showSaveConfirm.value = false }}
		footer={<>
			<AppDialogCancel onClick={() => { showSaveConfirm.value = false }}/>
			<AppBulkEditAction
				startIcon={<IconSeeker icon="check"/>}
				onClick={onSubmitModal}
				loading={isEditLoading}
			>
				Confirm & Save
			</AppBulkEditAction>
		</>}
	>
		<Box>
			{changes.length === 0
				? <Typography sx={{ fontSize: 14, color: dsColorNew.textMuted }}>No changes detected.</Typography>
				: <>
					<Typography sx={{ fontSize: 13, color: dsColorNew.textMuted, mb: 2 }}>
						The following changes will be saved:
					</Typography>
					<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mb: 2 }}>
						{changes.map(({ type, label, oldVal, newVal, added, removed }) => (
							<Box key={label}>
								<Typography variant="body2" fontWeight={600} sx={{ mb: 0.5 }}>{label}</Typography>
								{type === 'scalar' &&
									<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', pl: 1 }}>
										<Typography variant="body2" sx={{ color: dsColorNew.dangerRed, textDecoration: 'line-through' }}>{oldVal}</Typography>
										<IconSeeker icon="arrow-right" sx={{ fontSize: 12, color: dsColorNew.textMuted }}/>
										<Typography variant="body2" sx={{ color: dsColorNew.successText }}>{newVal}</Typography>
									</Box>
								}
								{type === 'password' &&
									<Typography variant="body2" sx={{ color: dsColorNew.noteAmber, pl: 1 }}>Password updated</Typography>
								}
								{type === 'array' &&
									<Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', pl: 1 }}>
										{added.map(item => (
											<Chip key={`add-${item}`} label={`+ ${item}`} size="small" sx={{ borderRadius: '6px', backgroundColor: dsColorNew.successBg, color: dsColorNew.successText, fontWeight: 500 }}/>
										))}
										{removed.map(item => (
											<Chip key={`rem-${item}`} label={`- ${item}`} size="small" sx={{ borderRadius: '6px', backgroundColor: dsColorNew.dangerBg, color: dsColorNew.dangerRed, fontWeight: 500 }}/>
										))}
									</Box>
								}
							</Box>
						))}
					</Box>
				</>
			}
		</Box>
	</AppModal>
}